import type {
  MoteStatus,
  MoteStatusReactionsTuple,
  MoteTheme,
  MoteVisibility
} from '@mote/api'

export class AnonymousExpiredMoteStatus implements MoteStatus {
  assignmentId = ''
  assignmentName = ''
  availableReactions = [] as any as MoteStatusReactionsTuple
  availableUnreactions = []
  canEdit = false
  canLink = false
  canReact = false
  canRedirect = false
  canReply = false
  className = ''
  containingURL = ''
  containingURLDescription = ''
  containingURLHeroImage = ''
  containingURLSiteImage = ''
  containingURLSiteName = ''
  containingURLTitle = ''
  createdAt = '1999-07-18T06:34:03.485885+0000'
  createdByAvatar = ''
  createdByGreeting = ''
  createdByName = ''
  createdByUserId = ''
  displayTitle = 'Expired Mote'
  domainSummary = ''
  duration = -1
  hasFailed = false
  hasTranscriptionFailed = false
  highestError = ''
  inMotebook = false
  isActive = false
  isAnonymous = true
  isFinalPlaybackLocation = false
  isLoopy = false
  isPlayable = false
  isQuiescent = false
  lastLoopMode = null
  lastSeenEpoch = -1
  lastTeply = null
  moteId = ''
  myReactions: [] = []
  niceTitle = ''
  playbackLocation = ''
  rawTitle = ''
  requiredScope = ''
  shouldPollForTranscription = false
  shouldRedirect = false
  showStemTranscript = false
  studentName = ''
  theme: MoteTheme = 'classic'
  title = ''
  transcriptDisplay = ''
  transcriptDisplayStem = ''
  transcriptPreview = ''
  transcriptionLanguage = ''
  transcriptionOptOut = false
  url = ''
  visibility: MoteVisibility = 'private'
  wasCreatedBySameUser = false
  translationLanguage = ''
}
